import { Component, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs'; 
import { formatNumber, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { VesselsService } from '../../../services/vessels.service';
import { PoolingPortalService } from '../../../services/pooling-portal.service';
import { DistributionDataService } from '../../../services/distributionData.service';
import { FiltersService } from '../../../services/filters.service';
import { StorageService } from '../../../services/storage.service';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { SubpoolService } from '../../../services/subpool.service';
import { FleetList, Filters, VesselDetails } from '../../../interface/fleetList.interface';
import { DropdownConfig } from "snl-complib";
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-fleet-management',
  templateUrl: './fleet-management.component.html',
  styleUrls: ['./fleet-management.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FleetManagementComponent {

  public ShipForm: UntypedFormGroup;
  public modifiedPoolPoint: UntypedFormGroup;
  public penaltyForm: UntypedFormGroup;
  public editShipForm: UntypedFormGroup;
  public statusForm: UntypedFormGroup;
  public moveShipForm: UntypedFormGroup;
  public editPenaltyForm: UntypedFormGroup;
  public subscription: Subscription;
 
  FleetList: FleetList = {
    isSelected : true,
    searchInput: true,
    iShipDetail: false,
    iNewPoolForm: false,
    iNewShipForm: false,
    iAddPenaltyForm: false,
    iModifyPoolPointForm: false,
    iEditPenaltyForm: false,
    iPenaltyForm:  false,
    iEditShipForm: false,
    iStatusForm: false,
    iCheckBox:true,
    allSelect: false,
    iAddNewSubPool:  false,
    iMoveShip:  false,
    iNotShip:  false,
    moveShipSubmit:  false,
    iConfirmModal:  false,
    isSkelton : false,
    isSkeltonSubpool : false,
    download:true,
    tab: '',
    fleet: '',
    searchText: '',
    szShipName:'',
    sortBy: 'subPool',
    sortValue: 'asc',
    revertAction: '',
    vslNumber: '',
    szShipNumber: '',
    szShipCode:  '',
    szShipOwner: '',
    confirmModalTitle: '',
    confirmModalDescription: '',
    shipOwners: [],
    subpool: [],
    vslClass:[],
    ship: [],
    owners:[],
    subPools:[],
    moveSubPools:[],
    subPoolList:[],
    subPoolVessels:[],
    allSubPoolVessels:[],
    // status: [
    //   { label: "Active", value: '1'},
    //   { label: "Inactive", value: '0'},
    // ],
    status: [
      { id:'', name:"Active"},
      { id:'', name:"Inactive"},
    ],
    setting : { showCloseIcon: false, backdropClick: false },
    vessels:[],
    monthNameArray: this._poolingPortalService.getMonthShortNames()
    
  }
 
  filters: Filters  = {
    ship: [],
    status:[],
    shipOwners: [],
    vslClass: [],
    subpool: [],
    vslNumber: [],
  }
  
  shipDetail: VesselDetails[] | any;
  vslClasses: any = [];
  subPools:any = [];
  shipOwners: any = [];
  newFleetlist: any = [];
  shipNames:any = [];
  fleetStatus:any;
  dropdownConfigNoSearch: DropdownConfig =  {
    showSearchBar: false,
    showActionButtons: false
  }
  shipFlowChart: string = '';
  showAllShips: boolean = true;
  checkedFlowchart_1: boolean = false;
  checkedFlowchart_2: boolean = false;
  getSubpoolList: any = [];
  addShipres: any = [];
  dateSelected: any;
  searchVal: any = [];
  disabledBtn: boolean = false;
  pointsFormval: any;
  getshipPool: any;
  getshipOwner: any;
  filterShipstatus: any = [];
  newfleetStatus: any = [];
  fleetMangdata: any = [];
  newOwners: any = [];
  allFleetlistVessel: any = [];
  getPoolData: any[] = [];
  selectedPagetab:string = 'all ships';
  formDataObj: any = {};
  newFormDataobj: any;
  subPoolFormdata: { };
  newSubPoolList: any = [];
 
  constructor(
    private fb: UntypedFormBuilder,
    private _vesselService: VesselsService,
    private _poolingPortalService: PoolingPortalService,
    private _filterService: FiltersService,
    private _storageService: StorageService,
    private router: Router,
    public datepipe: DatePipe,
    private _subpoolService: SubpoolService,
    private toasterService: ToasterService,
    private _distributionDataService: DistributionDataService,
  ) {
  }
  ngOnInit() {
    console.log(this.dropdownConfigNoSearch)
    document.body.style.overflow = "auto";
    this.subscription = this._poolingPortalService.fleet$.subscribe(
        fleet => {
          this.FleetList.isSkeltonSubpool = true;
          this.FleetList.isSkelton = true;
          this.FleetList.fleet = fleet;
          this.FleetList.tab = 'all';
          this.FleetList.iNotShip = false;
          this.filters['shipOwners'] = [];
          this.filters['vslClass'] = [];
          this.filters['status'] = [];
          this.filters['vslNumber'] = [];
          this.filters['ship'] = [];
          this.filters['subpool'] = [];
          this.getOwnerList();
          this.createModifiedPoolPointForm();
          this.createEditShipForm();
          this.createMoveShipForm();
          this.getSubPools();
          this.resetAddship();
         
        }
      )
    this.shipNames = this._vesselService.filterdFleetShipNames;
    this.shipOwners = this._vesselService.filteredFleetShipOwner;
    this.newfleetStatus = this._vesselService.filteredFleetStatus;
    console.log("this._vesselService.storePoolval111",this._vesselService.storePoolval)
    console.log("this._vesselService.addSubpoolfilterval1111",this._vesselService.addSubpoolfilterval)
    if(this._vesselService.storePoolval){
      this.selectedPagetab = this._vesselService.storePoolval;
      console.log("this.selectedPagetabmmmmmmmmmm",this.selectedPagetab)
      if(this._vesselService.storePoolval === 'SNAPS'){
        this.selectedPagetab = 'all ships';
      }
    }
    else{
      this.selectedPagetab = 'all ships';
        console.log("this.shhshdnndhd",this.selectedPagetab)
    }
    this.subscription = this._vesselService.navigateFleetlist.subscribe((res:any)=>{
      if(res){
        this.shipFlowChart = '';
        this.showAllShips = true;
         console.log("this._vesselService.storePoolval2222",this._vesselService.storePoolval)
        console.log("this._vesselService.addSubpoolfilterval2222",this._vesselService.addSubpoolfilterval)
        this.getVessels();
      }
    })
    this.subscription = this._distributionDataService.changeFleet.subscribe((res:any)=>{
        if(res){
          this.shipFlowChart = '';
          this.showAllShips = true;
          this._vesselService.storePoolval = '';
          this._vesselService.addSubpoolfilterval = '';
          this.selectedPagetab = 'all ships';
          this._vesselService.storegetPoolData = [];
          this._vesselService.filterdFleetShipNames = [];
          this._vesselService.filteredFleetShipOwner = [];
          this._vesselService.filteredFleetStatus = [];
          this.shipNames = [];
          this.shipOwners = [];
          this.newfleetStatus = [];
          this.filters['shipNames'] = [];
          // this.filters['ship'] = [];
        }
        console.log(this.filters)
      })
  }


  createModifiedPoolPointForm() {
    this.modifiedPoolPoint = this.fb.group({
      szShipCode: [''],
      szShipName: [''],
      poolPoint: [''],
      effectiveForm: [''],
    });
  }

  get mpp() { return this.modifiedPoolPoint.controls; }

  createEditShipForm() {
    this.editShipForm = this.fb.group({
      szShipCode: [''],
      szShipName: [''],
      subpool: [''],
      szOwner: [''],
      szClass: [''],
    });
  }

  get editShip() { return this.editShipForm.controls; }


  createMoveShipForm() {
    this.moveShipForm = this.fb.group({
      subPool: ['', Validators.required],
    });
  }
  get ms() { return this.moveShipForm.controls; }
  
  getVessels(formDataObj?:any) {
    console.log("formDataObj",formDataObj)
    if(formDataObj && Object.keys(formDataObj)?.length > 0){
      this.newFormDataobj = formDataObj;
      console.log("1")
    }else if(formDataObj === undefined || formDataObj === null){
      if(this._vesselService.addSubpoolfilterval){
        this._vesselService.storePoolval = this._vesselService.addSubpoolfilterval;
        console.log("storePoolval2222",this._vesselService.storePoolval)
      }else{
        this._vesselService.storePoolval = this.selectedPagetab;
      }
      console.log("uuuu3u3u",this._vesselService.storePoolval)

      if(this._vesselService.storePoolval){
        this.newFormDataobj = {'fleet':this.FleetList.fleet,'subPool':this._vesselService.storePoolval};
        console.log("33")
      }else{
        this.newFormDataobj = { "fleet": this.FleetList.fleet};
        console.log("22")
      }
      console.log("2")
    }
    else{
      this.newFormDataobj = { "fleet": this.FleetList.fleet};
      console.log("3")
    }
    if(this.newFormDataobj !== undefined || this.newFormDataobj !== null){
      this._vesselService.getVessels(this.newFormDataobj)
        .subscribe({
          next: (res) => {
            if (res.data.getVessels.success) {
              this.FleetList.vessels = res.data.getVessels.vessels;
              console.log(this.FleetList.vessels)
              this.filterShipstatus = this.FleetList.vessels;
              this.fleetMangdata = this.FleetList.vessels;
              this.allFleetlistVessel = this.FleetList.vessels;
              console.log(" this.getPoolData",this.getPoolData)
              console.log(" this._vesselService.storegetPoolData",this._vesselService.storegetPoolData)
              if(this._vesselService.storegetPoolData?.length){
                this.getPoolData = this._vesselService.storegetPoolData;
                console.log("esselService.storePoolval",this._vesselService.storePoolval)
                this.selectedPagetab = this._vesselService.storePoolval;
                console.log("meww", this.getPoolData)
                console.log("meww", this.selectedPagetab)
              }
              if(this.selectedPagetab === 'all ships'){
                this.getPoolData = [];
                this.getPoolData = this.FleetList.vessels?.map((x:any)=>x?.subPool) || [];
                this.getPoolData = this.getPoolData.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x === obj));
                console.log("this.getPoolData",this.getPoolData)
                // this._vesselService.storegetPoolData = this.getPoolData;
                if(this.newSubPoolList?.length){
                  this.getPoolData = this.getPoolData?.map((items:any)=>{
                    let filteredSubPool = this.newSubPoolList?.filter((data:any)=> data?.name === items);
                    console.log(filteredSubPool)
                    return items = {name:filteredSubPool[0]?.name,sequence:filteredSubPool[0]?.sequenceNumber}
                  })
                  this.getPoolData = this.getPoolData.sort((a, b) => a.sequence - b.sequence);
                  console.log("new pool data",this.getPoolData)
                  this._vesselService.storegetPoolData = this.getPoolData;
                }
              }
              this.FleetList.status = this.filterShipstatus.map((item:any,i:any)=>({id:item?.status,name:item?.status}))
              this.fleetStatus = this.FleetList.status.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
              console.log("status3",this.fleetStatus)
              this._vesselService.addSubpoolfilterval = '';
              this.applyFilter();
              this.refreshDropdownData();
            }
            else if(res.data.getVessels.message == 'Access denied'){
              this.router.navigate(['distribution'])
              return;
            }
            else if(res.data.getVessels.message == 'No Record Found'){
              this.FleetList.vessels = [];
              this.refreshDropdownData();
            }
          }
        });
    }
  }
  
  getOwnerList() {
    this._distributionDataService.getOwnerList(this.FleetList.fleet)
      .subscribe({
        next: (res:any) => {
          this.FleetList.owners = res.data.getOwnersList.data;
          this.FleetList.owners =  this.FleetList.owners.map((items:any)=>({id:items?.value,name:items.label}))
          console.log(this.FleetList.owners)
          this.newOwners = this.FleetList.owners;
          this.FleetList.shipOwners = this._filterService.shipOwners(this.FleetList.vessels,this.filters,  this.FleetList.owners);      
          console.log(this.FleetList.shipOwners)
          this.getVessels();
          this.getSubPoolVessel();
        }
      });
  }

  getSubPools() {
    let formData = { "fleet": this.FleetList.fleet};
    this._subpoolService.getSubPools(formData)
      .subscribe({
        next: (res) => {
          if (res.data?.getSubpoolsList.success) {
            this.FleetList.isSkeltonSubpool = false;
            this.FleetList.subPools = res.data.getSubpoolsList.subpools.map((subpool: any) => subpool.name);
            this.FleetList.subPoolList = res.data.getSubpoolsList.subpools;
            this.newSubPoolList = res.data.getSubpoolsList.subpools;
            console.log("this.FleetList.subPoolList",this.FleetList.subPoolList)
            this.getSubpoolList = this.FleetList.subPoolList?.map((items:any)=>({id:items?.subpoolCode,name:items?.name}))
            console.log("this.getSubpoolList",this.getSubpoolList)
            if(this.FleetList.fleet == 'SNAPS'){
              this.FleetList.tab = this.FleetList.subPools[0];
            }
          }
          else{
            this.FleetList.isSkeltonSubpool = false;
            this.FleetList.subPools= [];
            this.FleetList.subPoolList = [];
          }
        }
      });
  }

  getSubPoolVessel(subPool: any = '') {
    if(subPool){
      this.subPoolFormdata = { "subPool": subPool,"fleet": this.FleetList.fleet};
    }else if(this._vesselService.storePoolval){
      if(this._vesselService.addSubpoolfilterval){
        this._vesselService.storePoolval = this._vesselService.addSubpoolfilterval;
      }else{
        this._vesselService.storePoolval = this.selectedPagetab;
      }
      this.subPoolFormdata = { "subPool": this._vesselService.storePoolval,"fleet": this.FleetList.fleet};
    }else{
      this.subPoolFormdata = {"fleet": this.FleetList.fleet};
    }
    
  
    this._vesselService.getSubpoolVessels(this.subPoolFormdata)
      .subscribe({
        next: (res: any) => {
          if (res.data.getVessels.success) {
            this.FleetList.isSkelton = false;
            this.FleetList.allSubPoolVessels = res.data.getVessels.vessels;
            this.FleetList.iNotShip = (this.FleetList.allSubPoolVessels.length > 0) ? false : true;
            this.FleetList.subPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
            console.log("this.FleetList.subPoolVessels",this.FleetList.subPoolVessels)
            // this.FleetList.subPoolVessels.sort(this.compareValues(this.FleetList.sortBy, this.FleetList.sortValue));
             this._vesselService.addSubpoolfilterval = '';
          }
          else{
            this.FleetList.isSkelton = false;
            this.FleetList.iNotShip = true;
            this.FleetList.allSubPoolVessels = [];
            this.FleetList.subPoolVessels = [];
          }
        },
        error: (error) => {
          this.FleetList.isSkelton = false;
          
        }
      });
  }
  onPageTabClick(subPool: any) {
    this.FleetList.iNotShip = false;
    this.FleetList.tab = subPool;
    this.FleetList.allSubPoolVessels = [];
    this.FleetList.subPoolVessels = [];
    this.filters['subpool'] = [];
    subPool = (subPool == 'all') ? '' : subPool;
    if(subPool){
      this.filters['subpool'] = [subPool];
    }
    this.FleetList.isSkelton = true;
    // this.getSubPoolVessel(subPool);
    // this.getVessels();
    this.filters['vslClass'] = [];
    this.filters['shipOwner'] = [];
    this.filters['vslNumber'] = [];
    this.FleetList.allSelect = false;
    this.refreshDropdownData();
    this.FleetList.isSelected = false;
  }

  public sorting(sortBy: string, sortValue: string) {
    this.FleetList.sortBy = sortBy;
    this.FleetList.sortValue = sortValue;
    this.FleetList.subPoolVessels.sort(this.compareValues(sortBy, sortValue));
  }

  public compareValues(key: any, order = 'asc') {
    return function innerSort(a: any, b: any) {
      let x = a;
      let y = b;
      if (!x.hasOwnProperty(key) || !y.hasOwnProperty(key)) {
        return 0;
      }
      const varA = (typeof x[key] === 'string')
        ? x[key].toUpperCase() : x[key];
      const varB = (typeof b[key] === 'string')
        ? y[key].toUpperCase() : y[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  public removeRefreshData() {
    let that = this;
    let selectedValue: any = [];
    this.FleetList.subPoolVessels.forEach(function (x: any) {
      if (that.filters['vslNumber'].indexOf(x.vslNumber) >= 0) {
        selectedValue.push(x.vslNumber);
      }
    });
    this.filters['vslNumber'] = selectedValue;

  }

  public resetDropdown(event: any, field: string) {
    if ((this.shipNames?.length && field === 'shipNames') || (this.shipOwners?.length && field === 'shipOwners') || 
      (this.newfleetStatus?.length && field === 'status')) {
      this.filters[field] = [];
      this.FleetList.vessels = this._filterService.stjsfilter(this.FleetList.vessels, this.filters);
     
      if (field === 'shipNames') {
        this.shipNames = [];
      } else if (field === 'shipOwners') {
        this.shipOwners = [];
      }else if(field === 'status') {
        this.newfleetStatus = [];
      }
      this.applyFilter();
      this.refreshDropdownData();
    }
  }
  
  public resetAll() {
    this.filters['shipOwners'] = [];
    this.filters['status'] = [];
    this.filters['shipNames'] = [];
    console.log(this.FleetList.vessels)
    console.log(this.filters)
    this.FleetList.vessels = this._filterService.stjsfilter(this.FleetList.vessels, this.filters);
    console.log(this.FleetList.vessels)
    this.FleetList.ship = [];
    this.FleetList.shipOwners = [];
    this.shipOwners = [];
    this.shipNames = [];
    this.newfleetStatus = [];
    this.applyFilter();
    this.refreshDropdownData();
    this.FleetList.searchText = '';
    this.FleetList.searchInput = false;
  }

  public resetActivate() {
    return (this.filters['shipOwners']?.length || this.filters['shipNames']?.length ||  this.filters['status']?.length ||
    this.shipOwners.length > 0 || this.shipNames.length > 0 || this.newfleetStatus.length > 0)
    ? true : false;
  }

  applyFilter(){
    const selectedShips = (this.shipNames || []).map((s:any) => s.name.toLowerCase().trim());
    const selectedOwners = (this.shipOwners || []).map((s:any) => s.id.toLowerCase().trim());
    const fleetStatus = (this.newfleetStatus || []).map((s:any) => s.id.toLowerCase().trim());
    this.FleetList.vessels = this.fleetMangdata?.filter((items:any)=>
      (!selectedShips?.length || selectedShips?.includes(items?.vslName.toLowerCase().trim())) && 
      (!selectedOwners?.length || selectedOwners?.includes(items?.vslOwner.toLowerCase().trim())) &&
      (!fleetStatus?.length || fleetStatus?.includes(items?.status.toLowerCase().trim()))   
    )
    console.log( this.FleetList.vessels)
    if(this.newfleetStatus?.length){
      let vesselData = this.FleetList.vessels;
      let newvesselData = vesselData?.map((x:any)=>x?.vslOwner)
      this.FleetList.shipOwners = this.newOwners.filter((x:any)=>newvesselData.includes(x?.id))
      console.log(this.FleetList.shipOwners)
      this.FleetList.ship =  this._filterService.ships(vesselData, this.filters);
    }else{
      let vesselData = this.FleetList.vessels;
      this.fleetStatus = vesselData?.map((x:any)=>({id:x?.status,name:x?.status}));
      this.fleetStatus = this.fleetStatus.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
      console.log(this.fleetStatus)
    }
    console.log("fleet2",this.fleetStatus)
    if((this.shipNames?.length && !this.shipOwners?.length && !this.newfleetStatus?.length) ||
      (this.shipNames?.length && this.shipOwners?.length)){
      let vesselData = this.FleetList.vessels;
      let newvesselData = vesselData?.map((x:any)=>x?.vslOwner)
      this.FleetList.shipOwners = this.newOwners.filter((x:any)=>newvesselData.includes(x?.id))
      console.log(this.FleetList.shipOwners)
      this.fleetStatus = vesselData?.map((x:any)=>({id:x?.status,name:x?.status}));
      console.log("fleet",this.fleetStatus)
    }
    if(!this.shipNames?.length && this.shipOwners?.length && !this.newfleetStatus?.length){
      let vesselData = this.FleetList.vessels;
      this.fleetStatus = vesselData?.map((x:any)=>({id:x?.status,name:x?.status}));
      console.log("fleet2",this.fleetStatus)
      this.fleetStatus = this.fleetStatus.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
      console.log(this.fleetStatus)
    }
   
    this._vesselService.filterdFleetShipNames =  this.shipNames?.length ?  this.shipNames : [];
    this._vesselService.filteredFleetShipOwner = this.shipOwners?.length ? this.shipOwners : [];
    this._vesselService.filteredFleetStatus = this.newfleetStatus?.length ? this.newfleetStatus : [];
 }
  public refreshDropdownData() {
    if(this.FleetList.owners?.length){
      if(this.filters.ship['selectedRecords']?.length){
        this.filters.ship = this.filters.ship['selectedRecords'].map((record: any) => record.name);
        console.log(this.filters.ship)
      }
      if(this.filters.shipOwners['selectedRecords']?.length){
        this.filters.shipOwners = this.filters.shipOwners['selectedRecords'].map((record: any) => record.id);
       
      }
       console.log("this.filters.shipOwners",this.filters.shipOwners)
      console.log("this.FleetList.owners",this.FleetList.owners )
      console.log(this.filters)
      console.log("ts file",this.FleetList.vessels)
      this.FleetList.shipOwners = this._filterService.shipOwners(this.allFleetlistVessel,this.filters,this.FleetList.owners);
      console.log("this.FleetList.shipOwners2",this.FleetList.shipOwners )
      this.FleetList.shipOwners = this.FleetList.shipOwners.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
      console.log(this.FleetList.shipOwners)
      // this.newFleetlist =  this.FleetList.shipOwners.map((items:any)=>({id:items?.id,name:items.name}))
      // console.log(this.newFleetlist)
    }
    if(this.filters.subpool['selectedRecords']?.length){
      this.filters.subpool = this.filters.subpool['selectedRecords'].map((record: any) => record.name);
    }
    if (!this.filters.ship?.length || this.filters.ship?.length === undefined) {
      this.filters.ship = [];
    }
    console.log("this.FleetList.vessels",this.FleetList.vessels)
    console.log("this.FleetList.vessels",this.allFleetlistVessel)
    this.FleetList.ship = this._filterService.ships(this.allFleetlistVessel, this.filters);
    console.log("this.shipNames",this.shipNames)
    // this.FleetList.shipOwners = this._filterService.shipOwners(this.FleetList.vessels, this.filters,this.FleetList.owners);
    // this.FleetList.vslClass = this._filterService.vslClass(this.FleetList.vessels, this.filters);
    // this.FleetList.vslClass =  this.FleetList.vslClass.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
    // this.FleetList.subpool = this._filterService.subpools(this.FleetList.vessels, this.filters);
    // this.FleetList.subpool =  this.FleetList.subpool.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
    console.log("fleet2222",this.fleetStatus)
   
  }
  public selectedValues(event: any, field: string) {
    // this.filters[field] = event;
    this.filters[field] = event.selectedRecords?.map((items:any) =>items?.id);
    console.log("this.filters[field]",this.filters[field])
    this.refreshDropdownData(); 
    // this.FleetList.vessels = this._filterService.stjsfilter(this.FleetList.vessels, this.filters);
    this.FleetList.vessels = this._filterService.stjsfilter(this.allFleetlistVessel, this.filters);
     if(field === 'shipOwners'){
      this.shipOwners =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
      console.log("store3",this.shipOwners)
    }else if(field === 'shipNames'){
      this.shipNames =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
      console.log("store4",this.shipNames)
    }else if(field === 'status'){
       this.newfleetStatus = this.filters[field]?.map((items:any) =>({id:items,name:items}))
        console.log("store5",this.newfleetStatus)
    }
    console.log(this.FleetList.shipOwners)
    //  this.removeRefreshData();
    // if (this.FleetList.allSelect) {
    //   this.selectAll()
    // }
    this.applyFilter();
    console.log("status3",this.fleetStatus)
  }
  valuechange(value: any) {
    console.log(value)
    if (value) {
      this.filters['ship'][0] = value;
    }
    else {
      this.filters['ship'] = [];
    }
    this.refreshDropdownData();
    this.FleetList.subPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
    if (this.FleetList.allSelect) {
      this.selectAll()
    }
  }

  // public selectVessel(vessel: string) {
  //   let index = this.filters['vslNumber'].indexOf(vessel);
  //   if (!this.filters['vslNumber'].includes(vessel)) {
  //     this.filters['vslNumber'].push(vessel);
  //   }
  //   else {
  //     this.filters['vslNumber'].splice(index, 1);
  //   }

  // }

  public clearSection() {
    this.filters['vslNumber'] = [];
    this.FleetList.allSelect = false;
  }

  public selectAll() {
    let stjsintermediate:boolean =  this.stjsintermediate()
    this.filters['vslNumber'] = [];
    if(!stjsintermediate && !this.FleetList.allSelect){
      this.FleetList.allSelect = true;
    }
    else{
      this.FleetList.allSelect = false;
    }
    if (this.FleetList.allSelect && !stjsintermediate) {
      let allSubPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
      allSubPoolVessels.forEach((it: any) => {
        this.filters['vslNumber'].push(it.vslNumber);
      });
    }
  }

  public allSelectClick() {
    this.filters['vslNumber'] = [];
    this.FleetList.allSelect = true;
    let allSubPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
      allSubPoolVessels.forEach((it: any) => {
        this.filters['vslNumber'].push(it.vslNumber);
      });
      this.FleetList.iCheckBox = false;
      setTimeout(() => {
        this.FleetList.iCheckBox = true;
    }, 1);
  }

  addNewShipFrom() {
    this.FleetList.iNewShipForm = false;
  }

  shipAction(action: any, shipDetail: any) {
    this.shipDetail = shipDetail;
    this.FleetList.vslNumber = shipDetail.vslNumber;

    switch (action) {
      case 'modify_pool_point':
        this.FleetList.iModifyPoolPointForm = true;
        this.createModifiedPoolPointForm();
        break;

      case 'add_penalty':
        this.FleetList.iPenaltyForm = true;
        this.FleetList.iAddPenaltyForm = true;
        this.FleetList.iEditPenaltyForm = false;
        break;

      case 'edit_penalty':
        this.FleetList.iPenaltyForm = true;
        this.FleetList.iEditPenaltyForm = true;
        this.FleetList.iAddPenaltyForm = false;
        break;

      case 'edit_ship':
        this.FleetList.iEditShipForm = true;
        break;

      case 'status':
        this.FleetList.iStatusForm = true;
        break;

      case 'revert_poolpoint':
        this.FleetList.confirmModalTitle = "Revert to Nominal Pool Points";
        this.FleetList.revertAction = "pool_point";
        this.FleetList.iConfirmModal = true;
        break;

      case 'revert_penalty':
        this.FleetList.confirmModalTitle = "Revert Penalty Changes";
        this.FleetList.revertAction = "penalty";
        this.FleetList.iConfirmModal = true;
        break;

      case 'revert_close_penalty':
        this.FleetList.confirmModalTitle = "Revert Close Penalty Changes";
        this.FleetList.revertAction = "closepenalty";
        this.FleetList.iConfirmModal = true;
        break;

      case 'revert_status':
        this.FleetList.confirmModalTitle = `Revert to ${shipDetail.updatedStatus == 'active' ? 'Inactive' : 'Active'} Status`;
        this.FleetList.revertAction = "status";
        this.FleetList.iConfirmModal = true;
        break;

        case 'delete_ship':
        this.FleetList.confirmModalTitle = "Revert Activation & Delete Ship";
        this.FleetList.confirmModalDescription = "The action will be reverted and chosen ship will be deleted from "+ this.FleetList.fleet +" Fleet";
        this.FleetList.revertAction = "delete";
        this.FleetList.iConfirmModal = true;
        break;

      default:
        break;
    }
  }

  createPdf() {
    let doc = new jsPDF('p', 'mm', [210, 297]);
    let y = 10;
    doc.setLineWidth(1);
    doc.setFontSize(13);
    doc.text(this.FleetList.fleet + " - Fleet", 100, y);
    doc.setFontSize(10);
    if (this.FleetList.tab != 'all') {
      doc.text("Sub Pool : " + this.FleetList.tab, 15, y + 5);
    }
    doc.setFont("Roboto");
    console.log(this.filters);
    let downloadData = this._filterService.stjsfilterItemsDownload(this.FleetList.allSubPoolVessels, this.filters);
    downloadData.sort(this.compareValues(this.FleetList.sortBy, this.FleetList.sortValue));
    let data: any = []
    downloadData.forEach((subPoolVessel: any) => {
      let valueArray = [subPoolVessel.vslName];
      if(this.FleetList.tab == 'all'){
        valueArray.push(subPoolVessel.subPool)
      }
      valueArray.push(subPoolVessel.vslClass,this._poolingPortalService.getVslOwnerLabel(subPoolVessel.vslOwner,this.FleetList.owners),subPoolVessel.fleet);
      if(this.FleetList.fleet != 'SNAPS'){
        valueArray.push((subPoolVessel.scbrPoints) ? formatNumber(subPoolVessel.scbrPoints, 'en', '1.1-1'): '-');
      }
      valueArray.push(formatNumber(subPoolVessel.poolPoint, 'en', '1.2-2'))
      data.push(valueArray);
    });

    let columnStyles: any = { 0: { cellWidth: 60 }, 4: { halign: 'right' }, 5: { halign: 'right' } }
    let head:any = [];
    head.push('Ship');
    if ((this.FleetList.tab == 'all')) {
      head.push('Sub Pool');
      columnStyles = { 0: { cellWidth: 60 }, 5: { halign: 'right' }, 6: { halign: 'right' } }
    }
    head.push('Class', 'Ship Owner', 'Fleet')
    if(this.FleetList.fleet !='SNAPS'){
      head.push('Scrubber Points');
    }
    head.push('Pool Points');
    autoTable(doc, {
      body: data,
      startY: 20,
      theme: 'grid',
      head: [head],
      headStyles: { lineWidth: 0.3, fillColor: [211, 211, 211], textColor: '#27364B' },
      styles: { halign: 'center', fontSize: 9 },
      columnStyles: columnStyles,
    })
    let filename = this.FleetList.monthNameArray[Number(new Date().getMonth())].toUpperCase() + '-' + new Date().getFullYear().toString().slice(-2) + '_'+ this.FleetList.fleet +'.pdf'
    if(this.FleetList.download){
      doc.save(filename);
    }
    return filename;

  }

  createXlxs() {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Sheet1');
    let columns:any = [{ header: 'Ship', key: '', width: 40 }];
    if ((this.FleetList.tab == 'all')) {
        columns.push({ header: 'Sub Pool', key: '', width: 20 })
    }
    columns.push(
      { header: 'Class', key: '', width: 20 },
      { header: 'Ship Owner', key: '', width: 20 },
      { header: 'Fleet', key: '', width: 20 },
    )
    if ((this.FleetList.fleet != 'SNAPS')) {
      columns.push({ header: 'Scrubber Points', key: '', width: 20 })
    }
    columns.push({ header: 'Pool Points', key: '', width: 15 })
    worksheet.columns = columns;
    let downloadData = this._filterService.stjsfilterItemsDownload(this.FleetList.allSubPoolVessels, this.filters);
    downloadData.sort(this.compareValues(this.FleetList.sortBy, this.FleetList.sortValue));
    downloadData.forEach((subPoolVessel: any) => {
      let data = [subPoolVessel.vslName];
      if(this.FleetList.tab == 'all'){
        data.push(subPoolVessel.subPool)
      }
      data.push(subPoolVessel.vslClass,this._poolingPortalService.getVslOwnerLabel(subPoolVessel.vslOwner,this.FleetList.owners),subPoolVessel.fleet);
      if(this.FleetList.fleet != 'SNAPS'){
        data.push((subPoolVessel.scbrPoints) ? Number(subPoolVessel.scbrPoints): '-');
      }
      data.push(Number(subPoolVessel.poolPoint))
      let row = worksheet.addRow(data, 'n');
      row.eachCell(function(cell, colNumber) {
        if((colNumber == 5 || colNumber == 6 || colNumber == 7)){
          cell.style = { numFmt : "#,##0.0"};
        }
      })

    });
    let filename = this.FleetList.monthNameArray[Number(new Date().getMonth())].toUpperCase() + '-' + new Date().getFullYear().toString().slice(-2) + '_'+ this.FleetList.fleet +'.xlsx'
    worksheet.getRow(1).font = { bold: true, size: 12 };
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      if(this.FleetList.download){
        saveAs(blob, filename, { autoBom: false });
      }
    })
    return filename;
  }

  public checkBox(vslNumber: string) {
   if (this.filters['vslNumber'].includes(vslNumber) || this.FleetList.allSelect) {
      return true;
    }
    else {
      return false;
    }
  }

  /* public moveShip() {
    this.FleetList.iMoveShip = true;
    this.FleetList.moveSubPools = [...this.FleetList.subPools];
    if(this.FleetList.tab != 'all'){
      const index = this.FleetList.moveSubPools.indexOf(this.FleetList.tab);
      if (index > -1) {
        this.FleetList.moveSubPools.splice(index, 1); 
      }
    }
  } */

  closeShip(event: any) {
    this.FleetList.iNewShipForm = false;
    if (this._storageService.getDataFromStorage("listReloadAction") == "yes") {
      this.onPageTabClick(event);
      this._storageService.removeDataFromStorage("listReloadAction");
    }

  }

  getDateAsStringPattern(date: Date | null = null) {
    date = date || new Date();
    let dateNew = new Date(date);
    let day = dateNew.getDate();
    let month = dateNew.getMonth() + 1;
    let year = dateNew.getFullYear();
    return `${String(year)}-${(month < 10) ? ('0' + month) : String(month)}-${(day < 10) ? ('0' + day) : String(day)}`;
  }

  rowClick(event, vessel) {
    if (event) {
      this.FleetList.iShipDetail = true;
      this.shipDetail = vessel;
      this.FleetList.vslNumber = vessel.vslNumber;
    }
  }

  closeShipDetail(event: any) {
    this.FleetList.iShipDetail = false;
    this.FleetList.vslNumber = '';
    if (event) {
      this.onPageTabClick(this.FleetList.tab);
    }
  }

  public closeMarkAsStatus(event) {
    this.FleetList.iStatusForm = false;
    if (!this.FleetList.iShipDetail) {
      this.refreshBody();
    }
  }

  public closeEditShip(event) {
    this.FleetList.iEditShipForm = false;
    if (!this.FleetList.iShipDetail) {
      this.refreshBody();
    }
  }

  public closePenality(event) {
    this.FleetList.iPenaltyForm = false;
    this.FleetList.iAddPenaltyForm = false;
    this.FleetList.iEditPenaltyForm = false;
    if (!this.FleetList.iShipDetail) {
      this.refreshBody();
    }
  }

  refreshSubpool(event) {
    this.getSubPools();
  }
  refreshBody() {
    if (this._storageService.getDataFromStorage("listReloadAction") == "yes") {
      this.onPageTabClick(this.FleetList.tab);
      this._storageService.removeDataFromStorage("listReloadAction");
    }
  }
  /* moveShipToSubpool() {
    this.FleetList.moveShipSubmit = true;
    let moveShipData = this._filterService.stjsfilterItemsDownload(this.FleetList.allSubPoolVessels, this.filters);
    let shipNumbers = moveShipData.map((x) => x.vslNumber);
    if (this.moveShipForm.invalid) {
      return;
    }
    this._subpoolService.moveShipsOfSubpool(shipNumbers, this.moveShipForm.value.subPool)
      .subscribe({
        next: (res: any) => {
          const response = res.data.updateSubPoolOfVessels;
          if (response.success) {
            this.closeShipToSubpool();
            this.toasterService.openToast('Success', response.message);
            this.onPageTabClick(this.FleetList.tab);
            this.createMoveShipForm();
            this.FleetList.moveShipSubmit = false;
          }
        },
        error: (error) => {
          console.log(error);
        }
      });

  } */

  onAction(status: boolean) {
    this.FleetList.iConfirmModal = false;
    if (status) {
      switch (this.FleetList.revertAction) {
        case "pool_point":
          this.revertPoolPoints();
          break;
        case "penalty":
          this.revertPenalty();
          break;
        case "closepenalty":
          this.revertClosePenalty();
          break;
        case "status":
          this.revertStatus();
          break;
        case "delete":
          this.deleteShip();
          break;

        default:
          break;
      }
    }
    this.FleetList.revertAction = "";
  }

  revertPoolPoints() {
    this._vesselService.revertPoolPoints(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertPoolPoints.success) {
            this.onPageTabClick(this.FleetList.tab);
            this.toasterService.openToast('Success', res.data.revertPoolPoints.message);
          }
        }
        
      });
  }

  revertPenalty() {
    this._vesselService.revertPenalty(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertPenalty.success) {
            this.onPageTabClick(this.FleetList.tab);
            this.toasterService.openToast('Success', res.data.revertPenalty.message);
          }
        }
      });
  }

  revertClosePenalty() {
    this._vesselService.revertClosePenalty(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertClosePenalty.success) {
            this.onPageTabClick(this.FleetList.tab);
            this.toasterService.openToast('Success', res.data.revertClosePenalty.message);
          }
        }
      });
  }

  revertStatus() {
    this._vesselService.revertStatus(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertStatus.success) {
            this.onPageTabClick(this.FleetList.tab);
            this.toasterService.openToast('Success', res.data.revertStatus.message);
          }
        }
      });
  }

  deleteShip()
  {
    this._vesselService.deleteVessel(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
            if (res.data.deleteVessel.success){
              this.onPageTabClick(this.FleetList.tab);
              this.toasterService.openToast('Success', res.data.deleteVessel.message);
            }
        }
    });
  }

  checkEffectiveDate(effectiveDate: string, effectiveTime: string = '') {
    let effectiveDateUTCNumber;
    if (effectiveTime && effectiveTime != "" && effectiveTime != null) {
      let hours = Number(effectiveTime.split(":")[0]);
      let minutes = Number(effectiveTime.split(":")[1]);
      effectiveDateUTCNumber = new Date(effectiveDate).setUTCHours(hours, minutes, 0, 0);
    } else {
      effectiveDateUTCNumber = new Date(effectiveDate).setUTCHours(0, 0, 0, 0);
    }
    let todayUTCNumber = new Date(new Date().toUTCString()).getTime();
    return (effectiveDateUTCNumber <= todayUTCNumber) ? true : false;
  }

  closeShipToSubpool(){
    //this.FleetList.iMoveShip = false;
    document.body.style.overflow = "auto";
  }
  public stjsintermediate(){
    let allSubPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
    if(this.filters['vslNumber'].length === 0 || (allSubPoolVessels.length == this.filters['vslNumber'].length)){
        return false;
    }
    return true;
  }

  public rowActive(vslNumber){
    if(vslNumber == this.FleetList.vslNumber){
       return true;
    }
    return false;
  }
//----- add ship------
  addShip(){
  
    this.FleetList.iNewShipForm = false;
    this.shipFlowChart = 'shipFlowChart_1'
    if( this.shipFlowChart === 'shipFlowChart_1'){
      document.body.classList.add('addShipScroll')
      document.body.classList.remove('newAddShipScroll')
    }
    this.checkedFlowchart_1 = false;
    this.checkedFlowchart_2 = false;
    console.log(this.shipFlowChart)
    this.showAllShips = false;
    this.addShipres = [];
    console.log("sam")
    let data = {fleet: this.FleetList.fleet }
     this._vesselService.getAddSubpoolVessels(data).subscribe({
      next:(res:any)=>{
        console.log(res)
        this.addShipres = res?.data?.getAddVesselList?.data;
        this._vesselService.getFleetval = this.FleetList.fleet;
      },
      error:(error:any)=>{

      }
     })
     
  }
  saveAndnext(data:any){
    if(data === 'shipFlowChart_2'){
      this.shipFlowChart = 'shipFlowChart_2'
      this.checkedFlowchart_1 = true;
      document.body.classList.add('newAddShipScroll')
    }else{
      this.shipFlowChart = 'shipFlowChart_3'
      this.checkedFlowchart_2 = true;
      document.body.classList.add('addShipScroll')
      document.body.classList.remove('newAddShipScroll')
    }
     console.log(this.shipFlowChart)
    
  }
  previous(data:any){
    if(data === 'shipFlowChart_1'){
       this.shipFlowChart = 'shipFlowChart_1';
       this.checkedFlowchart_1 = false;
       document.body.classList.add('addShipScroll')
      document.body.classList.remove('newAddShipScroll')
    }else{
      this.shipFlowChart = 'shipFlowChart_2';
      this.checkedFlowchart_2 = false;
      document.body.classList.add('newAddShipScroll')
    }
    console.log(this.shipFlowChart)
  }
  fetchShipdetails(data:any){
    console.log(data)
    this._vesselService.vesselNumber = data?.vslNumber;
    sessionStorage.setItem('vslNumber',data?.vslNumber)
    this._distributionDataService.changeFleet.next(false);
    this.router.navigate(["fleetmanagement/shipdetails"]);

  }
  getDateselected(e:any){
    console.log(e)
    this.dateSelected = e;
     this.checkDisableBtn();
    console.log(this.searchVal?.length)
    console.log(this._vesselService.serachShipData)

  }
  getSearchval(e:any){
    this.searchVal = e;
    this.checkDisableBtn();
    console.log("search",e)
    console.log(this.searchVal?.length)
  }
  getShipsubpool(e:any){
    console.log(e)
    this.getshipPool = e
    console.log(this.getshipPool)
    this.checkDisableBtn();
  }
  getShipowner(e:any){
     console.log(e)
    this.getshipOwner = e;
    console.log(this.getshipOwner)
    this.checkDisableBtn();
  }
  checkDisableBtn(){
  
    console.log(this._vesselService.addShipdateselected,this._vesselService.addShipfilterval?.selectedRecords?.name,this._vesselService.addSubpoolfilterval,this._vesselService.serachShipData)
    if(this.searchVal?.length  &&  
      this.dateSelected  && 
      this.getshipOwner && 
      this.getshipPool ){
      this.disabledBtn = true;
    }else{
      this.disabledBtn = false;
    }
  }
  pointsFormgroup(e:any){
    this.pointsFormval = e;
    console.log(this.pointsFormval)
  }
  submitShip(){
   this._vesselService.callSubmitship.next(true);
  }
  goBack(){
    // this.router.navigate(['fleetmanagement'])
    this.shipFlowChart = '';
    this.showAllShips = true;
    this._vesselService.addSubpoolfilterval= '';
    document.body.classList.remove('addShipScroll')
    document.body.classList.remove('newAddShipScroll');
    this.resetAddship();
  }
  clickTab(data:any){
    console.log(data)
   
    // if(this._vesselService.storePoolval){
    //   this.selectedPagetab = this._vesselService.storePoolval;
    // }else{
       
    // }
    this.selectedPagetab = data;
    this._vesselService.storePoolval = data;
    this.shipNames = [];
    this.shipOwners = [];
    this.newfleetStatus = [];
    this.filters['shipNames'] = [];
    this.filters['shipOwners'] = [];   
    this.filters['status'] = [];
    this.formDataObj = {'fleet':this.FleetList.fleet,'subPool':data}
    console.log("this.formDataObj",this.formDataObj)
    this.getVessels(this.formDataObj);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    document.body.classList.remove('addShipScroll')
  }

  resetAddship(){
    this._vesselService.serachShipData = [];
    // this._vesselService.addSubpoolfilterval = '';
    this._vesselService.addShipfilterval = {};
    this._vesselService.addShipdateselected = '';
    this._vesselService.scrubberToggleval = false;
    this._vesselService.lngToggleval = false;
    this.searchVal = [];
    if(this._vesselService.pointsVal?.points){
      this._vesselService.pointsVal.points = '';
    }
    if( this._vesselService.scrubberPointsval?.scrubberPoints){
      this._vesselService.scrubberPointsval.scrubberPoints = '';
    }
  }
}


